import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import { Element } from 'react-scroll';
import { SEMINAR_INFORMATION_TEXT_MAX_LENGTH, SEMINAR_INFORMATION_TEXT_MAX_LENGTH_DRAFT, } from '../../../../../../../define/consts/seminar/seminar_information';
import { propBool, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import CountText from '../../../../../../Ui/Common/CountText';
import InputError from '../../../../../../Ui/Common/InputError';
import PlainInput from '../../../../../../Ui/Common/PlainInput';
/**
 * セミナーのタイトル入力コンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormTitleField = (props) => {
    const { className, countClassName, disabled, iconClassName, input, inputClassName, meta, } = props;
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_title' }, { children: [_jsxs("div", Object.assign({ className: 'title_inner field' }, { children: [_jsx(PlainInput, { className: clsx('title_input', inputClassName), disabled: disabled, input: input, maxLength: SEMINAR_INFORMATION_TEXT_MAX_LENGTH_DRAFT, meta: meta, placeholder: `セミナータイトル（${SEMINAR_INFORMATION_TEXT_MAX_LENGTH}文字以内で入力してください）` }), !disabled && (_jsx(EditIcon, { className: clsx('title_icon', iconClassName) })), _jsx(InputError, { meta: meta })] })), !meta.error && (_jsx("div", Object.assign({ className: clsx('title_count', countClassName) }, { children: _jsx(CountText, { gt: 1, limit: SEMINAR_INFORMATION_TEXT_MAX_LENGTH, value: input.value }) })))] })) })));
};
SeminarOneFormTitleField.propTypes = {
    className: propStr(),
    countClassName: propStr(),
    disabled: propBool().isRequired,
    iconClassName: propStr(),
    input: propShape().isRequired,
    inputClassName: propStr(),
    meta: propShape().isRequired,
};
SeminarOneFormTitleField.defaultProps = {
    className: '',
    countClassName: '',
    iconClassName: '',
    inputClassName: '',
};
export default SeminarOneFormTitleField;
